import {ComponentStore} from '@ngrx/component-store';
import {Injectable} from '@angular/core';

export interface MenuStatusState {
  operationsOpened: boolean;
  profileOpened: boolean;
}

const emptyState = () => ({
  operationsOpened: false,
  profileOpened: false,
});

@Injectable({
  providedIn: 'root',
})
export default class MenuStatusStore extends ComponentStore<MenuStatusState> {
  public readonly operationsOpened$ = this.select(state => state.operationsOpened);
  public readonly profileOpened$ = this.select(state => state.profileOpened);

  constructor() {
    super(emptyState());
  }

  public saveOperationsOpen(opened: boolean): void {
    this.patchState(() => ({
      operationsOpened: opened
    }));
  }

  public saveProfileOpen(opened: boolean): void {
    this.patchState(() => ({
      profileOpened: opened
    }));
  }

  public syncOperationsOpened(): boolean {
    return this.get().operationsOpened;
  }

  public syncProfileOpened(): boolean {
    return this.get().profileOpened;
  }

  reset(): void {
    this.patchState(() => ({
      ...emptyState()
    }));
  }
}
